import React, { Component } from 'react';
import { Col, Row } from 'antd';
import ActiveDeliveryOtpCard from '../ActiveDeliveryOtpCard/ActiveDeliveryOtpCard';
import { ActiveOtp } from '../../api/models/deliveryOtps';

type ActiveDeliveryOtpsProps = {
  fetchActiveDeliveryOtps: () => void;
  activeDeliveryOtps: ActiveOtp[];
};

export class ActiveDeliveryOtps extends Component<ActiveDeliveryOtpsProps, any> {
  REFRESH_INTERVAL = 60 * 1000;
  _intervalId?: number;
  constructor(props: ActiveDeliveryOtpsProps) {
    super(props);
  }

  componentDidMount() {
    this.props.fetchActiveDeliveryOtps();

    this._intervalId = window.setInterval(this.props.fetchActiveDeliveryOtps, this.REFRESH_INTERVAL);
  }

  componentWillUnmount() {
    window.clearInterval(this._intervalId);
  }

  render() {
    const { activeDeliveryOtps } = this.props;
    return (
      <Row gutter={[0, 16]}>
        {activeDeliveryOtps.map(otp => (
          <Col span={24} key={`${otp.uuid}`}>
            <ActiveDeliveryOtpCard {...otp} />
          </Col>
        ))}
      </Row>
    );
  }
}

export default ActiveDeliveryOtps;
